import { useCallback } from 'react';

import { AutoPositionAction, FamilyTreeActionFn } from '../types';

export function useAutoPositionAction() {
  return useCallback<FamilyTreeActionFn<AutoPositionAction>>(
    (state, _action, queueEffect) => {
      // Queue the marriage layout effect to recompute positions
      queueEffect({ type: 'marriageLayoutEffect', isAutoPosition: true });

      return state;
    },
    []
  );
}
